import { AppLanguages } from 'app-constants';

export const isAppLanguage = (lang: string): lang is AppLanguages => {
  return Object.values(AppLanguages).includes(lang as AppLanguages);
};
